<template>
    <v-app-bar dense class="header">
        <v-toolbar-title>
            <v-avatar size="2.3rem" item class="mr-3">
                <v-img src="@/assets/images/sing.gif" alt="Vuetify"></v-img>
            </v-avatar>
        </v-toolbar-title>
        <div class="label">ตรวจสอบสถานะคำขอ</div>
        <v-spacer></v-spacer>
    </v-app-bar>
</template>
<script>

export default {
    data() {
        return {
            
        };
    },
    async mounted() {
    },
    methods: {

    }
};
</script>
